import './globals.css'
import type { Metadata } from 'next'

export const metadata: Metadata = {
  title: 'SenKredi Backoffice',
  description: 'Backoffice interne SenKredi',
}

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="fr">
      <body>{children}</body>
    </html>
  )
}
